import { SearchData } from "app/area/administration/list/types-store";
import { ComplexValue } from "app/types-shared";

export const userOptionsMapped = (list: SearchData[]): ComplexValue<number>[] =>
  list.map(item => ({
    value: item.id,
    description: `${item.personId}, ${item.name}`
  }));
